import React, { useState } from "react";
import Payment from "components/payment/Payment";
import PaymentActionBar from "components/payment/PaymentActionBar";
import "./payment.scss";
import { useTranslation } from "react-i18next";
import { checkRole } from "utils/Utils";
import { BRANCH_ADMIN, bGId } from "common/constants/constants";
import DownloadUserData from "components/common/downloadUserData/DownloadUserData";
import { invoicesRequest } from "services/bankServices";
import InvoicesRequestModal from "components/common/downloadUserData/InvoicesRequestModal";
import toast from "react-hot-toast";
const Billing = () => {
  const { t } = useTranslation();
  const [openInvoicesRequestMessage, setOpenInvoicesRequestMessage] = useState(false);
  const downloadUserData = async () => {
    const bankId = localStorage.getItem("bankId");
    let response = await invoicesRequest(bGId, bankId);
    if (response?.success) {
      setOpenInvoicesRequestMessage(true);
    }else{
      toast.error(t('invoice-request-error-message'))
    }
  };
  return (
    <div className="payment">
      <div className="custom-breadcrumbs ">
        <span className="breadcrumbs-item ">{t("billing")}</span>
      </div>

      <p>{t("total-monthly-income")}</p>
      <div className="row">
        <div className="col-sm-10">
          <h3>€ 0</h3>
        </div>
        <div className="col-sm-2">
          {checkRole() === BRANCH_ADMIN && (
            <div className="pl-5">
              <DownloadUserData
                buttonName={t("download-invoices")}
                btnHandler={() => {
                  downloadUserData();
                  //setOpenInvoicesRequestMessage(true);
                }}
              />
            </div>
          )}
        </div>
      </div>
      <PaymentActionBar />
      <Payment />
      <InvoicesRequestModal isOpen={openInvoicesRequestMessage} onClose={()=> {setOpenInvoicesRequestMessage(false)}}/>
    </div>
  );
};

export default Billing;
